$(document).ready(function () {
    $('#calculation-search-typeahead').typeahead({
        source: function (query, process) {
            return $.get('/portal/search/calculation-type-ahead?q=' + query, function (data) {
                return process(data);
            });
        },
        minLength: 1,
        items: 8,
        fitToElement: true,
        afterSelect: function () {
            $('#calculation-search-typeahead').parents('form').submit();
        }
    });
});